import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Theme,
  WithStyles,
  withStyles,
  Divider,
  Typography,
  MenuItem,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Paper,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { PHONE_REG_EXP, ROLE_TYPES, isEmpty } from "../constants/constants";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = (theme: Theme) => createStyles({});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  isAdmin: any;
  editData: any;
  handleClose: any;
  handleOnSubmit: any;
}
const addEmployeeValidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  email: Yup.string().email("Email is invalid"),
  password: Yup.string().required("Password is required"),
  employeeNumber: Yup.string().required("Employee number is required"),
  phone: Yup.string()
    .length(10, "Phone number needs to be 10 digits")
    .max(10, "Phone number needs to be 10 digits")
    .matches(PHONE_REG_EXP, "Please enter a valid mobile number."),
  dashboard: Yup.string().nullable(true),
  role: Yup.string().required("Select the role"),
});

const addAdministractorValidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  email: Yup.string().email("Email is invalid").required("Email is required"),
  password: Yup.string().required("Password is required"),
  phone: Yup.string()
    .length(10, "Phone number needs to be 10 digits")
    .max(10, "Phone number needs to be 10 digits")
    .matches(PHONE_REG_EXP, "Please enter a valid mobile number.")
    .required("Phone number is required"),
});

class AddingUsersDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    formIsDirty: false,
  };

  renderTextInput = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    selections?: any
  ) => {
    return (
      <div>
        {type === "text" && (
          <TextField
            style={{ margin: 10 }}
            id={id}
            // defaultValue={value}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            label={label}
            inputProps={
              id === "phone" || label.includes("Contact Number")
                ? { maxLength: 10 }
                : { maxLength: 170 }
            }
            fullWidth
          />
        )}
        {type === "select" && (
          <TextField
            style={{ margin: 10 }}
            select
            id={id}
            label={label}
            margin="dense"
            value={value ? value : ""}
            onChange={handleChange(id)}
            fullWidth
          >
            {selections.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
        <Typography
          variant={"subtitle1"}
          align={"right"}
          style={{
            color: "red",
            alignSelf: "right",
          }}
        >
          {error}
        </Typography>
      </div>
    );
  };

  renderAllInputField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    touched: any,
    setFieldValue: any
  ) => {
    let editData = this.props.editData && this.props.editData.fullName;
    return (
      <div>
        <div>
          {!this.props.isAdmin && (
            <div style={{ marginLeft: 10 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    id={"dashboard"}
                    name={"dashboard"}
                    checked={values.dashboard}
                    onChange={(event) => {
                      values.email = "";
                      values.employeeNumber = "";
                      values.phone = "";
                      setFieldValue("dashboard", event.target.checked);
                    }}
                    value="dashboard"
                  />
                }
                label="Dashboard user"
              />
            </div>
          )}
          {values.dashboard && (
            <FormHelperText style={{ marginLeft: 10 }}>
              When creating dashboard the Username must be .
            </FormHelperText>
          )}
          {this.renderTextInput(
            "text",
            "fullName",
            values.fullName,
            handleChange,
            handleBlur,
            "fullName",
            !values.dashboard ? "Full Name" : "Username",
            errors.fullName
              ? values.dashboard
                ? "Username required"
                : errors.fullName
              : ""
          )}

          {!editData &&
            this.renderTextInput(
              "text",
              "password",
              values.password,
              handleChange,
              handleBlur,
              "password",
              "Password",
              errors.password ? "Password required" : ""
            )}
        </div>

        {this.renderTextInput(
          "text",
          "email",
          values.email,
          handleChange,
          handleBlur,
          "email",
          "Email",
          errors.email
        )}

        {!this.props.isAdmin &&
          !values.dashboard &&
          this.renderTextInput(
            "text",
            "employeeNumber",
            values.employeeNumber,
            handleChange,
            handleBlur,
            "employeeNumber",
            "Employee Number",
            errors.employeeNumber
          )}

        {values.dashboard && (
          <Paper
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
              marginTop: 20,
              width: "100%",
            }}
          >
            <FormHelperText style={{ marginLeft: 10 }}>
              Assign this dashboard user to:
            </FormHelperText>
            <TextField
              style={{ margin: 10 }}
              id={"assignedFullName"}
              value={values.assignedFullName}
              onChange={handleChange}
              onBlur={handleBlur}
              name={"assignedFullName"}
              label={"Full Name"}
            />
            <TextField
              style={{ margin: 10 }}
              id={"assignedContactNumber"}
              value={values.assignedContactNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              name={"assignedContactNumber"}
              label={"Contact Number"}
              inputProps={{ maxLength: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  id={"isPassportNumber"}
                  name={"isPassportNumber"}
                  checked={values.isPassportNumber}
                  onChange={(event) => {
                    values.assignedIdentityNumber = "";
                    values.assignedPassportNumber = "";
                    setFieldValue("isPassportNumber", event.target.checked);
                  }}
                  value="isPassportNumber"
                />
              }
              label="Passport Number"
              style={{ marginLeft: 2 }}
            />
            {!values.isPassportNumber && (
              <TextField
                style={{ margin: 10 }}
                id={"assignedIdentityNumber"}
                value={values.assignedIdentityNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{ maxLength: 13 }}
                name={"assignedIdentityNumber"}
                label={"Identity Number"}
              />
            )}
            {values.isPassportNumber && (
              <TextField
                style={{ margin: 10 }}
                id={"assignedPassportNumber"}
                value={values.assignedPassportNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                name={"assignedPassportNumber"}
                label={"Passport Number"}
              />
            )}
          </Paper>
        )}

        {!values.dashboard &&
          this.renderTextInput(
            "text",
            "phone",
            values.phone,
            handleChange,
            handleBlur,
            "phone",
            "Phone (eg.0821234560)",
            errors.phone
          )}

        {!this.props.isAdmin &&
          !values.dashboard &&
          this.renderTextInput(
            "select",
            "role",
            values.role,
            handleChange,
            handleBlur,
            "role",
            "Role",
            errors.role,
            ROLE_TYPES
          )}
      </div>
    );
  };

  renderForm = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    isValid: any,
    touched: any,
    setFieldValue: any
  ) => {
    const { handleClose, handleOnSubmit } = this.props;
    return (
      <div>
        <Form>
          <div>
            {this.renderAllInputField(
              values,
              handleChange,
              handleBlur,
              errors,
              touched,
              setFieldValue
            )}
            <DialogActions>
              <Button
                onClick={() => {
                  handleClose();
                }}
              >
                {"CANCEL"}
              </Button>
              {values.dashboard && (
                <Button
                  onClick={() => handleOnSubmit(values)}
                  disabled={!values.dashboard && !isValid}
                >
                  {"SAVE"}
                </Button>
              )}
              {!values.dashboard && (
                <Button
                  type={"submit"}
                  disabled={!values.dashboard && !isValid}
                >
                  {"SAVE"}
                </Button>
              )}
            </DialogActions>
          </div>
        </Form>
      </div>
    );
  };

  render() {
    const { open, handleClose, editData, handleOnSubmit } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">
            {"Adding User"}
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                editData && editData.fullName
                  ? editData
                  : this.props.isAdmin
                  ? {
                      fullName: "",
                      email: "",
                      phone: "",
                    }
                  : {
                      fullName: "",
                      email: "",
                      employeeNumber: "",
                      phone: "",
                      dashboard: false,
                      isPassportNumber: false,
                      role: "",
                      password: "",
                      assignedIdentityNumber: "",
                      assignedPassportNumber: "",
                      assignedFullName: "",
                      assignedContactNumber: "",
                    }
              }
              validationSchema={
                !this.state.formIsDirty
                  ? this.props.isAdmin
                    ? addAdministractorValidationSchema
                    : addEmployeeValidationSchema
                  : null
              }
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                handleOnSubmit(values);
                resetForm();
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                errors,
                isValid,
                touched,
                setFieldValue,
              }) => (
                <Form>
                  <div>
                    {this.renderAllInputField(
                      values,
                      handleChange,
                      handleBlur,
                      errors,
                      touched,
                      setFieldValue
                    )}
                    <DialogActions>
                      <Button
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        {"CANCEL"}
                      </Button>
                      {values.dashboard && (
                        <Button
                          onClick={() => handleOnSubmit(values)}
                          disabled={!values.dashboard && !isValid}
                        >
                          {"SAVE"}
                        </Button>
                      )}
                      {!values.dashboard && (
                        <Button
                          type={"submit"}
                          disabled={!values.dashboard && !isValid}
                        >
                          {"SAVE"}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddingUsersDialog);
